import React from 'react';
import { EyeIcon, SparklesIcon } from 'lucide-react';
export function Visualization() {
  return <section className="w-full px-4 py-16 md:py-24 bg-dark" data-id="element-277">
      <div className="max-w-5xl mx-auto" data-id="element-278">
        <div className="flex items-center justify-center gap-3 mb-8" data-id="element-279">
          <EyeIcon className="w-8 h-8 md:w-10 md:h-10 text-primary" data-id="element-280" />
          <h2 className="text-[28px] md:text-[40px] lg:text-[56px] font-bold font-poppins text-white text-center tracking-tight uppercase" data-id="element-281">
            Cierra Los Ojos Por Un Momento
          </h2>
        </div>
        <div className="space-y-8" data-id="element-282">
          <p className="text-[18px] md:text-[22px] font-inter text-textGray text-center italic leading-relaxed max-w-[30ch] mx-auto" data-id="element-283">
            Mientras lees estas palabras... siente cómo algo dentro de ti{' '}
            <span className="text-primary font-bold" data-id="element-284">
              ya sabe que es posible.
            </span>
          </p>
          <div className="bg-lightBg p-8 md:p-16 rounded-3xl border-4 border-primary shadow-2xl" data-id="element-285">
            <p className="text-[28px] md:text-[36px] lg:text-[48px] font-bold font-poppins text-textDark text-center mb-10 tracking-tight uppercase" data-id="element-286">
              Imagínate en unos meses...
            </p>
            <div className="space-y-5 text-[16px] md:text-[18px] font-inter text-textDark" data-id="element-287">
              <div className="flex items-start gap-3 bg-dark p-6 rounded-2xl" data-id="element-288">
                <SparklesIcon className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-289" />
                <p className="text-white leading-relaxed" data-id="element-290">
                  Dominas una habilidad que{' '}
                  <span className="text-primary font-bold" data-id="element-291">
                    el mercado valora profundamente
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 bg-dark p-6 rounded-2xl" data-id="element-292">
                <SparklesIcon className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-293" />
                <p className="text-white leading-relaxed" data-id="element-294">
                  Ayudas a personas a tomar decisiones que{' '}
                  <span className="text-primary font-bold" data-id="element-295">
                    transforman sus vidas
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 bg-dark p-6 rounded-2xl" data-id="element-296">
                <SparklesIcon className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-297" />
                <p className="text-white leading-relaxed" data-id="element-298">
                  Tu tiempo es tuyo.{' '}
                  <span className="text-primary font-bold" data-id="element-299">
                    Tu familia te tiene presente.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 bg-dark p-6 rounded-2xl" data-id="element-300">
                <SparklesIcon className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-301" />
                <p className="text-white leading-relaxed" data-id="element-302">
                  Trabajas desde donde quieras.{' '}
                  <span className="text-primary font-bold" data-id="element-303">
                    Sin límites geográficos.
                  </span>
                </p>
              </div>
            </div>
            <div className="mt-10 p-8 bg-dark rounded-2xl border-2 border-primary/30" data-id="element-304">
              <p className="text-[18px] md:text-[22px] font-inter text-center text-textGray mb-5 leading-relaxed" data-id="element-305">
                Sin jefes. Sin horarios impuestos.
              </p>
              <p className="text-[24px] md:text-[32px] font-bold font-poppins text-center text-primary tracking-tight leading-[1.2] uppercase" data-id="element-306">
                Solo libertad, propósito y crecimiento continuo.
              </p>
            </div>
          </div>
          <p className="text-[18px] md:text-[22px] font-inter text-primary text-center font-bold italic" data-id="element-307">
            Ya puedes sentir cómo esa vida está más cerca de lo que pensabas...
          </p>
        </div>
      </div>
    </section>;
}